import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map, catchError, of } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    const files = [
      'es.json',
      'es.vacations.json',
      'es.food-benefit.json',
      'es.loans.json',
      'es.solidarity.json',
      'es.social-security.json',
    ];

    const requests = files.map(file =>
      this.http.get(`./assets/i18n/${file}`).pipe(catchError(() => of({})))
    );

    return forkJoin(requests).pipe(
      map(responses => Object.assign({}, ...responses))
    );
  }
}
